import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

export const AMEX_OFFER_URL = 'https://m.amex/amexoffers_1';

@Component({
	selector: 'app-amex-offer-modal',
	templateUrl: './amex-offer-modal.component.html',
	styleUrls: ['./amex-offer-modal.component.scss'],
})
export class AmexOfferModalComponent {
	readonly offerUrl = AMEX_OFFER_URL;
	readonly offerUrlLabel = AMEX_OFFER_URL.replace('https://', '');

	constructor(private modalCtrl: ModalController) {}

	static async show(modalCtrl: ModalController) {
		const modal = await modalCtrl.create({
			cssClass: 'auto-height amex-offer-modal',
			component: AmexOfferModalComponent,
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}
}
